/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Cookiebanner_Title1Inputs */

const id_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan Cookie`)
};

const ms_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notis Kuki`)
};

const da_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Meddelelse`)
};

const de_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie-Hinweis`)
};

const en_us2_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Notice`)
};

const es_es2_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de cookies`)
};

const es_mx2_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de cookies`)
};

const fil_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abiso sa Cookie`)
};

const fr_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avis sur les cookies`)
};

const it_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avviso sui cookie`)
};

const hu_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Süti tájékoztató`)
};

const nl_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie melding`)
};

const no_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informasjonskapselmelding`)
};

const pl_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacja o ciasteczkach`)
};

const pt_br2_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Notice`)
};

const pt_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de Cookies`)
};

const ro_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificare cookie-uri`)
};

const fi_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evästeilmoitus`)
};

const sv_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie-meddelande`)
};

const vi_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo Cookie`)
};

const tr_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çerez Bildirimi`)
};

const cs_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznámení o cookies`)
};

const bg_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Известие за бисквитки`)
};

const ru_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомление о cookie`)
};

const uk_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повідомлення про файли cookie`)
};

const ar_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إشعار ملفات تعريف الارتباط`)
};

const hi_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुकी सूचना`)
};

const th_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประกาศเกี่ยวกับคุกกี้`)
};

const ja_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie 通知`)
};

const zh_cn2_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Notice`)
};

const zh_hant1_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Notice`)
};

const ko_components_cookiebanner_title1 = /** @type {(inputs: Components_Cookiebanner_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Notice`)
};

/**
* | output |
* | --- |
* | "Cookie Notice" |
*
* @param {Components_Cookiebanner_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_cookiebanner_title1 = /** @type {((inputs?: Components_Cookiebanner_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Cookiebanner_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_cookiebanner_title1(inputs)
	if (locale === "ms") return ms_components_cookiebanner_title1(inputs)
	if (locale === "da") return da_components_cookiebanner_title1(inputs)
	if (locale === "de") return de_components_cookiebanner_title1(inputs)
	if (locale === "en-US") return en_us2_components_cookiebanner_title1(inputs)
	if (locale === "es-ES") return es_es2_components_cookiebanner_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_cookiebanner_title1(inputs)
	if (locale === "fil") return fil_components_cookiebanner_title1(inputs)
	if (locale === "fr") return fr_components_cookiebanner_title1(inputs)
	if (locale === "it") return it_components_cookiebanner_title1(inputs)
	if (locale === "hu") return hu_components_cookiebanner_title1(inputs)
	if (locale === "nl") return nl_components_cookiebanner_title1(inputs)
	if (locale === "no") return no_components_cookiebanner_title1(inputs)
	if (locale === "pl") return pl_components_cookiebanner_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_cookiebanner_title1(inputs)
	if (locale === "pt") return pt_components_cookiebanner_title1(inputs)
	if (locale === "ro") return ro_components_cookiebanner_title1(inputs)
	if (locale === "fi") return fi_components_cookiebanner_title1(inputs)
	if (locale === "sv") return sv_components_cookiebanner_title1(inputs)
	if (locale === "vi") return vi_components_cookiebanner_title1(inputs)
	if (locale === "tr") return tr_components_cookiebanner_title1(inputs)
	if (locale === "cs") return cs_components_cookiebanner_title1(inputs)
	if (locale === "bg") return bg_components_cookiebanner_title1(inputs)
	if (locale === "ru") return ru_components_cookiebanner_title1(inputs)
	if (locale === "uk") return uk_components_cookiebanner_title1(inputs)
	if (locale === "ar") return ar_components_cookiebanner_title1(inputs)
	if (locale === "hi") return hi_components_cookiebanner_title1(inputs)
	if (locale === "th") return th_components_cookiebanner_title1(inputs)
	if (locale === "ja") return ja_components_cookiebanner_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_cookiebanner_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_cookiebanner_title1(inputs)
	return ko_components_cookiebanner_title1(inputs)
});
export { components_cookiebanner_title1 as "components.cookieBanner.title" }